/**
 * Syncs authenticated user identity to GTM dataLayer.
 * Updates GTM user context whenever auth or organization state changes.
 * Clears GTM user context on sign-out.
 */

import type { ClerkOrganization, ClerkUser } from '@saaga/shared/interfaces/auth.interface'
import { clearGtmUser, setGtmUser } from '@saaga/shared/utils/gtm.util'
import { useEffect } from 'react'

export const useGtmUserSync = (
  user: ClerkUser | null,
  organization: ClerkOrganization | null
): void => {
  useEffect(() => {
    if (!user) {
      clearGtmUser()
      return
    }
    setGtmUser({
      userId: user.id,
      orgId: organization?.id ?? '',
      orgSlug: organization?.slug ?? '',
    })
  }, [user, organization])
}
